import { useMemo } from 'react';
import NoteAuthor from '@/components/NoteAuthor';
import NoteContent from '@/components/NoteContent';
import NoteErrorBoundary from '@/components/NoteErrorBoundary';
import NoteHead from '@/components/NoteHead';
import NoteTitle from '@/components/NoteTitle';
import { type INote, type INoteContent } from '@/types/INote';
import styles from './index.module.scss';

export default function Note ({ note }: { note: INote }) {
  const id = useMemo(() => `note-${note.id}`, [note.id]);
  const shallShowNoteAuthor = useMemo(() => note.noteAuthors && note.noteAuthors.length > 0, [note.noteAuthors]);
  const shallShowNoteTitle = useMemo(() => note.title !== '', [note.title]);

  return (
    <div
      className={styles.note}
      data-e='note'
      data-shall-animate-background={note._firstShow}
      id={id}
    >
      <div className={styles.note__header}>
        <NoteHead note={note} />
        {shallShowNoteAuthor ? <NoteAuthor authors={note.noteAuthors} /> : null}
        {shallShowNoteTitle ? <NoteTitle isUrgent={note.urgent} title={note.title} /> : null}
      </div>
      <div
        className={styles.note__content}
        data-e='note-content'
      >
        {note.content
          ? note.content.map((content: INoteContent, idx: number) => (
            <NoteErrorBoundary id={note.id} key={`note-content-${note.id}-${idx}`}>
              <NoteContent
                content={content}
                embedArticles={Object.keys(note.embedArticles).length > 0 ? note.embedArticles : undefined}
                noteId={note.id}
              />
            </NoteErrorBoundary>
          ))
          : null}
      </div>
    </div>
  );
}
